'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function isFinite(value) {
    return Number.isFinite(value);
}

exports.isFinite = isFinite;
